export default function getDefaultVariantsState(productData) {
  if (productData?.products) {
    let defaultColor;

    if (productData?.enable_color_variants) {
      defaultColor = productData?.product_color_variants?.find((variant) => {
        return variant.default_variant == true;
      });
    }

    let defaultSize;

    if (productData?.enable_size_variants) {
      defaultSize = productData?.product_size_variants?.find((variant) => {
        return variant.default_variant == true;
      });
    }

    let defaultVariant = {};

    if (defaultColor) {
      defaultVariant = {
        ...defaultVariant,
        color: defaultColor?.value,
        colorLabel: defaultColor.tr_label,
      };
    }

    if (defaultSize) {
      defaultVariant = {
        ...defaultVariant,
        size: defaultSize?.value,
        sizeLabel: defaultSize.tr_label,
      };
    }

    if (defaultVariant && productData?.variants_picker_type == "each") {
      const maxSize = productData?.products?.reduce((max, product) => {
        return Number(product.amount) > max ? Number(product.amount) : max;
      }, 0);

      return {
        defaultVariant: defaultVariant,
        variants: [...Array.from({ length: maxSize })].map(function (object, i) {
          return defaultVariant;
        }),
      };
    }

    if (defaultVariant && productData?.variants_picker_type == "separate") {
      const maxSize = productData.products?.reduce((max, product) => {
        return Number(product.amount) > max ? Number(product.amount) : max;
      }, 0);

      return {
        defaultVariant: defaultVariant,
        defaultSize: defaultSize,
        defaultColor: defaultColor,
        variants: [...Array.from({ length: maxSize })].map(function (object, i) {
          return defaultVariant;
        }),
      };
    }
  }
}
